import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jdai-home',
  templateUrl: './jdai-home.component.html',
  styleUrls: ['./jdai-home.component.scss']
})
export class JdaiHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
